import { render, staticRenderFns } from "./BimaBambaInstallments.vue?vue&type=template&id=7878af6e"
import script from "./BimaBambaInstallments.vue?vue&type=script&lang=js"
export * from "./BimaBambaInstallments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports